
import { Component, Vue } from "vue-property-decorator";

@Component
export default class LoadingTypeCard extends Vue {
  public items: Array<number> = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
}
